import {ActionList} from '@primer/react'
import type {CondensedStatusRow} from '../../helpers/condensed-merge-status-presentation'

interface MergeStatusRowProps {
  row: CondensedStatusRow
  /**
   * Called when the row is selected. The clicked element is passed back so
   * focus can be restored to it when the merge status panel closes.
   */
  onSelect: (returnFocusTo: HTMLElement | null) => void
}

/**
 * A single merge requirement summary row. Rendered as an `ActionList.Item` so it
 * reuses Primer's interactive row styling — the same affordance the Activity
 * section uses to open the side panel — rather than a bespoke button.
 */
export function MergeStatusRow({row, onSelect}: MergeStatusRowProps) {
  return (
    <ActionList.Item onSelect={event => onSelect(event.currentTarget)}>
      <ActionList.LeadingVisual>
        <span style={{color: row.iconColor}}>
          <row.icon size={16} />
        </span>
      </ActionList.LeadingVisual>
      {row.label}
      {row.detail ? <ActionList.Description variant="inline">{row.detail}</ActionList.Description> : null}
    </ActionList.Item>
  )
}
